import React from "react";
import { Typography } from "@mui/material";
import styled from "@mui/system/styled";

const ContributerItem = styled("div")`
  .contributer-title {
    text-transform: capitalize;
  }
  .contributer-name {
  }
  & > :last-child {
    margin-bottom: 4px;
  }
`;

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key].toLowerCase()] = rv[x[key].toLowerCase()] || []).push(x);
    return rv;
  }, {});
};

const Contributers = ({ contributers = null }) => {
  if (contributers && contributers.length > 0) {
    const contributersByType = groupBy(contributers, "type");
    return Object.keys(contributersByType).map((key) => {
      const printList = [
        ...new Map(
          contributersByType[key].map((v) => [
            JSON.stringify([v.name.toLowerCase(), v.type.toLowerCase()]),
            v,
          ])
        ).values(),
      ];
      return (
        <ContributerItem key={`contributer-${key}`}>
          <Typography className="contributer-title" variant="subtitle2">
            <strong>
              {key}
              {": "}
            </strong>
          </Typography>
          {printList.map(({ name }) => (
            <Typography
              className="contributer-name"
              variant="body2"
              key={`contributer-${key}-${name}`}
            >
              {name}
            </Typography>
          ))}
        </ContributerItem>
      );
    });
  }
  return null;
};

export default React.memo(Contributers);
